import React, { useEffect } from "react";
import ProfileContainer from "../../containers/ProfileContainer/ProfileContainer";
import { useServiceUserCreationCtx } from "../../context/ServiceUserCreationContext";

export default function ProfilePage() {
  const { pageTypeCtx } = useServiceUserCreationCtx();
  const [, setPageType] = pageTypeCtx;
  useEffect(() => {
    setPageType("");
  }, []);

  return (
    <>
      <div>
        <ProfileContainer></ProfileContainer>
      </div>
    </>
  );
}
